export default __webpack_public_path__ + "static/media/vocalnet2.ac399dec.mp4";